import { dispatcher } from 'dispatcher';
import React, { memo, useCallback } from 'react';
import { prop } from 'ramda';
import { Button } from '@core/js/components/common/Button';
import { useComponentConfig } from '@core/js/hooks/component';

import * as Types from '@core/js/components/main/GamesGrid/components/Game/components/GamePlayButton/types';
import { IGamesGridConfig } from '@core/js/components/main/GamesGrid/types';
import { useDynamicReducerSelector } from '@core/js/components/main/GamesGrid/store';
import { useAssetRedirectData } from '@theme/js/components/common/Game/hooks/useAssetRedirectData';
import { useNavigate } from '@theme/js/hooks/navigate';

import style from './GamePlayButton.scss';

export const GamePlayButtonBare: React.FC<Types.IGamePlayButtonProps> = ({ game, className = '' }) => {
    const navigate = useNavigate(); // Lugano changes
    const { gameCode: code, liveConfiguration } = game;
    const feedName = useDynamicReducerSelector(prop('feedName'));
    const { queryStringParameters: queryString } = useComponentConfig<IGamesGridConfig>();
    const { isArticleIdPathPresent, linkToPage } = useAssetRedirectData(code, 'gameGrid'); // Lugano changes

    const onClick = useCallback(() => {
        if (isArticleIdPathPresent) {
            navigate(linkToPage); // Lugano changes
        } else {
            dispatcher.dispatch('game:launch', { code, container: 'games-grid', gameFeed: feedName, mode: 1, queryString });
        }
    }, [code, feedName, queryString, isArticleIdPathPresent, linkToPage, navigate]);

    if (liveConfiguration?.isScheduled) {
        return null;
    }

    /* Lugano changes */
    return (
        <Button
            isNew
            onClick={onClick}
            className={`${style.button} ${className} cms-games-grid-game-play-button`}
        />
    );
};

export const GamePlayButton = memo(GamePlayButtonBare);
